import React from 'react'
import {TextField} from 'formik-material-ui'
import {FC} from 'react'

import Field from 'components/Field'
import {FieldComponentProps} from 'components/TextField'

const ReadOnlyTextField: FC<FieldComponentProps> = (props) => (
  <Field
    component={TextField}
    exampleValue={'' as string}
    disabled
    {...props}
  />
)

export default ReadOnlyTextField
